import { createAsyncThunk } from '@reduxjs/toolkit';

import { _apiPathManagerConfig } from 'Shared/ApiPaths/ApiPathManagerSetup';
import { onResultWithDataStatus } from 'Shared/HttpServices/Utils/utils';

import IEstelamShakhsSalesCommand from '../SakhsSalesBimehNameh/Commands/Estelam/IEstelamShakhsSalesCommand';
import { KhodroHttpPostService } from '../Services/KhodroHttpService';

export const estelamShakhsSales = createAsyncThunk(
  'estelamShakhsSales',
  async (command: IEstelamShakhsSalesCommand) => {
    return await KhodroHttpPostService({
      url: `${_apiPathManagerConfig?.Khodro.BimehNamehHayeShakhsSales.EstelamShakhsSales}`,
      body: command,
      onResult: onResultWithDataStatus,
    });
  }
);
